import React from 'react'

export const COMPANIES = {
	care: React.lazy(() => import('./care')),
}
